import React from 'react';
import { Header } from '../Header';
export var AppShell = function (_a) {
    /*const [mappings, setMappings] = useState<
      Map<number, ItemToBin> | undefined
    >();
    const fetchMappings = useGetBinMappings();
  
    useEffect(() => {
      if (!fetchMappings) return;
      setMappings(fetchMappings);
    }, [fetchMappings]);*/
    var children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        children));
};
